<template>
  <div class="swatches-view-wrapper">
    <ul
      class="swatches-view-wrapper-tabs"
      :class="{
        'splash-swatches-view-tabs': isMobile,
      }"
      ref='swatchesViewTabs'
    >
      <li class="tab-randomize" :class="[{ 'hide': !isRandomizeEnabled || isApparel }, { 'disabled': $store.state.utils.isRandomizeApplied }]">
        <button :aria-label="translations.tabRandomize" :aria-hidden="!isRandomizeEnabled || isApparel" role="button" @click="onRandomizeClick()" id="randomize" class="tab-name tab-randomize__name">
          <div class="tab-randomize__name__dynamic-background">
            <div class="background-content" />
          </div>
          <span class="tab-randomize__name__value">{{ translations.tabRandomize }}</span>
          <span aria-hidden="true" class="tab-randomize__name__icon icon icon-randomize"></span>
        </button>
      </li>

      <li
        v-for="(tab) in getTabsSwatches"
        @click="changeTab(tab)"
        :key="tab.name"
        :class="[
          'tab-' + tab.name,
          { active: active_tab === tab.name },
          { deactivated: disabledTab(tab) || rayTracerDisabled },
          { hide: hideTab(tab) }
        ]"
      >
        <button :aria-label="tab.display_name" :aria-hidden="hideTab(tab)" role="button" :id="tab.name" class="tab-name">
          <span v-show="tab.name === 'add-your-own'">
            <span v-show="tab.name === 'add-your-own'" class="ugc-upcharge">{{
              ugcUpcharge
            }}</span>
          </span>
          <span
            v-tooltip="{ ...ugcTooltipData, classes: 'swatches-view-v-popover ugc-tooltip-data' }"
            v-show="hasUGCTooltip(tab.name)"
            class="ugc-tooltip"
            >?</span
          >
          {{ tab.display_name }}
          <span
            class="configurator-swatch-count"
            v-show="tab.name !== 'add-your-own' && tab.name !== 'image-gallery' && tab.name && tab.name !== 'personalization' && tab.name !== 'yourcolors'"
            >({{ !ugcBlockedTab ? tab.total : 1 }})</span
          >
          <span v-show="tab.name === 'add-your-own'" class="camera-icon">
            <svg
              width="16"
              height="16"
              viewBox="0 0 512 512"
              style="position: relative; top: 2px; left: 1px;"
            >
              <path
                d="M152 304c0 57.438 46.562 104 104 104s104-46.562 104-104-46.562-104-104-104-104 46.562-104 104zM480 128h-112c-8-32-16-64-48-64h-128c-32 0-40 32-48 64h-112c-17.6 0-32 14.4-32 32v288c0 17.6 14.4 32 32 32h448c17.6 0 32-14.4 32-32v-288c0-17.6-14.4-32-32-32zM256 446c-78.425 0-142-63.574-142-142s63.575-142 142-142c78.426 0 142 63.575 142 142s-63.573 142-142 142zM480 224h-64v-32h64v32z"
              ></path>
            </svg>
          </span>
          <span v-show="tab.name === 'yourcolors'" class="color-picker-icon-container">
            <span
              class="color-picker-icon"
            ></span>
          </span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import Tabs from "@/mixins/Tabs";


export default {
  name: "tabs",
  mixins: [
    Tabs
  ],
  created() {
    if (this.$store.state.utils.isDesignTransfering) {
      this.$store.commit('swatches/CLEAR_STATE_IN_TRANSFERING_DESIGN');
      this.$eventBus.$emit("blockRelationSwatches");
      this.loadedComponentSelectedTab();
      this.setHistoryTab();
      this.initGroup = 4;
    }
    this.$eventBus.$on("selectedTab", this.loadedComponentSelectedTab);
    this.$eventBus.$on("disable-ugc-tab", this.blockUGCTab);
    this.$eventBus.$on("changeTab", this.changeTab);
    this.$eventBus.$on('block-features-by-swatch-id', this.disablePersonalizationTab);
    this.$eventBus.$on('block-features-by-precreated-recipe', this.blockFeaturesByRecipeID);
    this.$eventBus.$on('select-previous-tab', this.selectPreviousTab);
    this.$eventBus.$on('resetPropertiesInit', this.resetPropertiesInit);
  },
  beforeDestroy() {
    this.$eventBus.$off("selectedTab", this.loadedComponentSelectedTab);
    this.$eventBus.$off("disable-ugc-tab", this.blockUGCTab);
    this.$eventBus.$off("changeTab", this.changeTab);
    this.$eventBus.$off('block-features-by-swatch-id', this.disablePersonalizationTab);
    this.$eventBus.$off('block-features-by-precreated-recipe', this.blockFeaturesByRecipeID);
    this.$eventBus.$off('select-previous-tab', this.selectPreviousTab);
    this.$eventBus.$off('resetPropertiesInit', this.resetPropertiesInit);
  }
};
</script>